import {
  getByIdExerciseSelector,
  getByIdWorkoutSelect
} from '@gymaholic/packages'
import getByIdPlanSelector from '@gymaholic/packages/src/modules/plans/selectors/get-by-id'
import { getAliasCategoriesSelector } from 'modules/categories/selectors'
import getPathsEditingSelector from 'modules/editing/selectors/get-paths'
import getPathFromRouteAndMatchReduxUtil from 'modules/redux/utils/get-path-from-route-and-match'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import getLocationRouterSelect from 'modules/router/selectors/get-location'
import getRouteAndMatchRouteUtil from 'modules/routes/utils/get-route-and-match'
import { getObjectUtil } from 'packages/src'

const ROUTE_PATH_TO_INSTANCE_PATH = {
  [ROUTE_PATH.WORKOUT_BY_ID_SLUG]: ({
    match,
    state
  }) => {
    return getByIdWorkoutSelect(match?.params?.id)(state)
  },
  [ROUTE_PATH.WORKOUT_BY_ID]: ({
    match,
    state
  }) => {
    return getByIdWorkoutSelect(match?.params?.id)(state)
  },
  [ROUTE_PATH.PLAN_BY_ID_SLUG]: ({
    match,
    state
  }) => {
    return getByIdPlanSelector(match?.params?.id)(state)
  },
  [ROUTE_PATH.PLAN_BY_ID]: ({
    match,
    state
  }) => {
    return getByIdPlanSelector(match?.params?.id)(state)
  },
  [ROUTE_PATH.ADD_EXERCISE]: ({
    match,
    state
  }) => {
    return getByIdExerciseSelector(match?.params?.id)(state)
  },
  [ROUTE_PATH.VIEW_EXERCISE]: ({
    match,
    state
  }) => {
    return getByIdExerciseSelector(match?.params?.id)(state)
  },
  [ROUTE_PATH.VIEW_EXERCISE_SLUG]: ({
    match,
    state
  }) => {
    return getByIdExerciseSelector(match?.params?.id)(state)
  }
}

/**
 * Returns a selector that selects the instance.
 * @returns {Function}
 */
function getInstanceSectionSelector () {
  /**
   * Returns the instance.
   * @param  {Object} state
   * @param  {Object} props
   * @returns {Instance|undefined}
   */
  return (state, props) => {
    const location = getLocationRouterSelect(state)
    const {
      route,
      match
    } = getRouteAndMatchRouteUtil(location?.pathname)

    // logUtil('getInstanceSectionSelector').info('props=', props)
    const path = getObjectUtil(route, 'path') || ''
    const isNew = path.endsWith('/new')
    if (
      !route ||
      !path ||
      (
        !route.section &&
        !isNew
      )
    ) {
      const func = ROUTE_PATH_TO_INSTANCE_PATH[path]
      return func
        ? func({
            match,
            state
          })
        : null
    }

    // If it's a /new route, return the new instance
    if (isNew) {
      const paths = getPathsEditingSelector()(state)
      return getObjectUtil(state, paths[paths.length - 1])
    }

    // If there is a category, get its alias
    let { category } = match.params
    if (category) {
      category = getAliasCategoriesSelector(route.section, category)(state)
      match.params = {
        ...match.params,
        category
      }
    }

    // Return the instance
    return getObjectUtil(
      state,
      getPathFromRouteAndMatchReduxUtil(route, match)
    )
  }
}

export default getInstanceSectionSelector
